<template>
  <div>
    <div v-if="model">
        <div class="block">
            <b-checkbox v-model="notification">
                Notification
            </b-checkbox>
            <b-checkbox v-model="comment">
                Comments
            </b-checkbox>
        </div>
    </div>
    <base-table
      :service="$options.notificationService"
      fetch-func="all"
      :fetch-params="params"
      :columns="columns"
      default-sort-direction="desc"
      :narrowed="false"
      ref="baseTable"
    >
      <template #rowDate="{ row }">
        {{ convertDate(row) }}
      </template>
      <template #rowData="{ row }">
        <b-button size="is-small" @click="openData(row)">
          DATA
        </b-button>
      </template>
    </base-table>
    <b-modal :active.sync="modalData"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal>
      <div class="modal-card" style="width: auto: min-width:300px;">
            <section class="modal-card-body">
                <vue-json-pretty
                :path="'res'"
                :data="dataResult">
                </vue-json-pretty>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="modalData = false">Close</button>
            </footer>
            </div>
        </b-modal>
  </div>
</template>
<script>
import BaseTable from "@/components/partials/BaseTable";
import { NotificationService } from "@/services/notification.service";
import VueJsonPretty from 'vue-json-pretty'
import moment from "moment";
export default {
  notificationService: NotificationService,
  props: ['type', 'model', 'perPage'],
  components: {
    BaseTable,
    VueJsonPretty,
  },
  data: () => ({
    notification: true,
    comment: false,
    modalData: false,
    dataResult: null
  }),
  computed: {
    params() {
        let data = {
            includes: "createdBy",
            per_page: this.perPage ? this.perPage : 20,
        };
        if (this.type) {
            data.type  = this.type;
            data.model = this.model.id;
        }
        return data;
    },
    columns() {
        let columns = [];
        columns.push({field: "Date", label: "Created At", meta: {
            rowSlot: "rowDate"
        }});
        if (! this.type) {
            columns.push({field: "notifiableType", label: "Model"});
            columns.push({field: "notifiableId", label: "Model ID"});
        }

        columns.push({field: "subtype", label: "Type"});
        columns.push({field: "sender", label: "Sender", meta: {
            valuePath: "createdBy.firstName"
        }});
        if (! this.type) {
            columns.push({field: "recipient", label: "Recipient"});
        }
        // columns.push({field: "status", label: "Status"});
        columns.push({field: "data", label: "", meta: {
            rowSlot: "rowData"
        }});
        return columns;
    }
  },
  watch: {
    model() {
      this.$nextTick(() => {
        this.fetch();
      });
    }
  },
  filters: {
    data(data) {
      return JSON.stringify(data || {});
    }
  },
  methods: {
    fetch() {
      return this.$refs.baseTable.fetchData();
    },
    openData(data) {
        this.dataResult = data.data;
        this.$nextTick(() => {
            this.modalData = true;
        });
    },
    convertDate(row) {
      return moment(row.createdAt).format('MMMM DD YY hh:mm:ss');
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Notifications/list/partials/table.vue